import get from 'lodash.get';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { selectAppliedFertilizerEntitiesByDate } from 'services/appliedFertilizerEntitiesByDate/selectors';
import { FertilizerEntityId } from 'services/fertilizerEvents/types';
import { Props } from './index';

const selectEntityId = (state: AppState, props: Props): FertilizerEntityId =>
    props.entityId;

const selectEntityHasBeenAppliedAlready = createDeepEqualSelector(
    selectAppliedFertilizerEntitiesByDate,
    selectEntityId,
    (appliedEntities, entityId) => Boolean(get(appliedEntities, entityId))
);

const makeSelectEntityHasBeenAppliedAlready =
    (): typeof selectEntityHasBeenAppliedAlready =>
        selectEntityHasBeenAppliedAlready;

export { selectEntityId, makeSelectEntityHasBeenAppliedAlready };
